var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.704,
    height: 16.563,
    viewBox: "0 0 20.704 16.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-round-drive-folder-upload",
    "data-name": "Icon material-round-drive-folder-upload",
    d: "M21.634,8.07H13.352l-1.46-1.46A2.077,2.077,0,0,0,10.423,6H5.07A2.068,2.068,0,0,0,3.01,8.07L3,20.493a2.077,2.077,0,0,0,2.07,2.07H21.634a2.077,2.077,0,0,0,2.07-2.07V10.141A2.077,2.077,0,0,0,21.634,8.07Zm-7.247,7.247v3.106a1.035,1.035,0,0,1-2.07,0V15.317H10.464a.512.512,0,0,1-.362-.88L13,11.549a.522.522,0,0,1,.735,0l2.888,2.888a.522.522,0,0,1-.373.88Z",
    transform: "translate(-3 -6)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.2c6aabb6ef74262fb8482f0ad043edab.svg";
export { ForwardRef as ReactComponent };